<template>
    <div class="switcher">
        <label class="switcher__label">
            <input
                v-model="checked"
                @change="$emit('change', $event.target)"
                :disabled="disable == '1' ? true : false"
                class="switcher__input"
                type="checkbox"
                :checked="checked"
            />
            <span><small></small></span>
        </label>
        <input
            v-if="name"
            type="hidden" 
            :name="name" 
            :value="checked ? '1' : '0'"
        />
    </div>
</template>
<script>
export default {
  props: {
    disable: String,
    value: String,
    name: String,
  },
  data() {
    return {
      checked: this.value == "1" ? true : false,
    };
  },
};
</script>
